module.exports = __webpack_public_path__ + "static/img/lxwm_bg.92bffec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lxwm_bg.png
// module id = XZg0
// module chunks = 1